<template>
    <tr>
        <td>{{ this.rigaPianoDiManutenzione.TipoFrequenzaTemporale }}</td>
        <td>{{ this.rigaPianoDiManutenzione.DescrAttivita }}</td>
        <td>{{ this.rigaPianoDiManutenzione.TipoFrequenzaTemporale }}</td>
        <td>{{ this.rigaPianoDiManutenzione.FrequenzaTemporale }}</td>
        <td>{{ this.formatDateNoOre(this.rigaPianoDiManutenzione.DataProssima) }}</td>
        <td>{{ this.formatDateNoOre(this.rigaPianoDiManutenzione.DataUltima) }}</td>
        <td>{{ this.rigaPianoDiManutenzione.Manutentore }}</td>
        <td><a href="/CmsData/imagefolder/Manuale.pdf" target="_blank" class="Download">Man.123456/21</a></td>
    </tr>
</template>

<script>
import {dateMixin} from "/mixin.js";

export default {
    name: "RigaGrigliaPianoDiManutenzione",
    mixins:[dateMixin],
    props: {
        rigaPianoDiManutenzione: Object
    }
}

</script>